import { BreadcrumbsProps } from "design-system/components/primitives/breadcrumbs/breadcrumbs";
import { BreadcrumbStructuredData } from "design-system/components/primitives/head/head";
import { SiteEntry } from "frontend/contentful/schema/universal";

export function getBreadcrumbStructuredData(
  breadcrumbs: BreadcrumbsProps,
  site?: SiteEntry,
): BreadcrumbStructuredData | undefined {
  if (!site?.fields.domain) {
    return undefined;
  }

  const domain =
    site?.fields.domain === "exed" || site?.fields.domain === "library"
      ? `www.${site?.fields.domain}`
      : site?.fields.domain || "www";

  const listItems: BreadcrumbStructuredData["itemListElement"] = [];
  let position = 1;

  if (site?.fields.domain !== "www") {
    listItems.push({
      "@type": "ListItem",
      position,
      name: "Harvard Business School",
      item: "https://www.hbs.edu",
    });
    position++;
  }

  breadcrumbs.breadcrumbs.forEach((breadcrumb) => {
    const name = breadcrumb.title;
    const item = breadcrumb.link
      ? `https://${domain}.hbs.edu${breadcrumb.link}`
      : undefined;

    if (name && item) {
      listItems.push({
        "@type": "ListItem",
        position,
        name,
        item,
      });
      position++;
    } else {
      console.warn(
        `Breadcrumb at position ${position} is missing a name and will be skipped in structured data.`,
        breadcrumb,
      );
    }
  });

  const breadcrumbDataProps: BreadcrumbStructuredData = {
    "@type": "BreadcrumbList",
    itemListElement: listItems,
  };

  return breadcrumbs.breadcrumbs.length > 0 ? breadcrumbDataProps : undefined;
}
